import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { getNetworkFromLabel } from '@/utils/dq';
import { EditorialFacebookPostNetwork } from '@/utils/enums';

type UseNetwork = () => [EditorialFacebookPostNetwork, string];

const useNetwork: UseNetwork = () => {
  const { network } = useParams();

  const numericNetwork = useMemo(() => {
    return getNetworkFromLabel(network);
  }, [network]);

  return [numericNetwork!, network!];
};

export default useNetwork;
